import React from "react";
import avatar from "../img/avatar.jpg";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="NavBar">
      <nav className="nav">
        <div className="profile">
          <img src={avatar} alt="" />
        </div>

        <ul className="nav-items">
          <li className="nav-item">
            <NavLink to="/" exact activeClassName="active">
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/skills" exact activeClassName="active">
              Skills
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/projects" exact activeClassName="active">
              Projects
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/blogs" exact activeClassName="active">
              Blogs
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/contact" exact activeClassName="active">
              Contact
            </NavLink>
          </li>
        </ul>

        <footer className="footer">
          <p>Copyright © {currentYear}. All rights reserved.</p>
        </footer>
      </nav>
    </div>
  );
};

export default Navbar;
